import { STORES } from "../../content";
import { useT } from "../../i18n/LangContext";

const AppleIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}>
    <path d="M16.37 1.43c0 1.14-.5 2.27-1.18 3.08-.74.9-1.99 1.57-2.99 1.57-.12 0-.23-.02-.3-.03-.01-.06-.04-.22-.04-.39 0-1.15.57-2.27 1.21-2.98.8-.94 2.14-1.64 3.25-1.68.03.13.05.28.05.43zm4.56 15.71c-.03.07-.46 1.58-1.52 3.12-.94 1.34-1.94 2.71-3.43 2.71-1.52 0-1.9-.88-3.63-.88-1.7 0-2.3.91-3.67.91-1.38 0-2.33-1.26-3.43-2.8C4 18.38 2.96 15.57 2.96 12.92c0-4.28 2.8-6.55 5.55-6.55 1.45 0 2.68.95 3.6.95.87 0 2.22-1.01 3.9-1.01.61 0 2.89.06 4.37 2.19-.13.09-2.38 1.37-2.38 4.19 0 3.26 2.85 4.42 2.95 4.45z" />
  </svg>
);

const PlayIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}>
    <path d="M3.6 1.8c-.3.3-.5.8-.5 1.4v17.6c0 .6.2 1.1.5 1.4l9.9-10.2L3.6 1.8zm10.9 11.3 2.6 2.7-11.4 6.5c-.5.3-1 .3-1.4.1l10.2-9.3zm0-2.2L4.3 1.6c.4-.2.9-.2 1.4.1l11.4 6.5-2.6 2.7zm3.8-1.9 3 1.7c1 .6 1 1.9 0 2.5l-3 1.7-2.8-2.9 2.8-3z" />
  </svg>
);

const ICONS = { "google-play": PlayIcon, "app-store": AppleIcon };

const StoreButton = ({ store, text, comingSoon }) => {
  const Icon = ICONS[store.id];
  const live = Boolean(store.href);
  const Tag = live ? "a" : "div";
  const props = live ? { href: store.href, target: "_blank", rel: "noopener noreferrer" } : { "aria-disabled": true };
  return (
    <Tag
      {...props}
      className={`relative flex h-14 items-center gap-3 rounded-lg bg-black px-5 text-white transition-colors ${live ? "hover:bg-zinc-800" : "cursor-default"}`}
      data-testid={`store-btn-${store.id}`}
    >
      <Icon className="h-6 w-6 shrink-0" />
      <span className="flex flex-col text-left leading-tight">
        <span className="text-[11px] font-medium">{text.kicker}</span>
        <span className="text-[17px] font-semibold">{text.label}</span>
      </span>
      {!live && (
        <span className="absolute -right-2 -top-2.5 whitespace-nowrap rounded-full bg-[#FFD000] px-2 py-0.5 text-[11px] font-bold text-black shadow-sm" data-testid={`store-badge-${store.id}`}>
          {comingSoon}
        </span>
      )}
    </Tag>
  );
};

export const StoreButtons = () => {
  const t = useT().stores;
  const anyLive = STORES.some((s) => s.href);
  return (
    <div data-testid="store-buttons">
      <div className="flex flex-wrap gap-4">
        {STORES.map((s) => (
          <StoreButton key={s.id} store={s} text={t[s.id]} comingSoon={t.comingSoon} />
        ))}
      </div>
      {!anyLive && (
        <p className="mt-3 text-sm text-zinc-600" data-testid="store-coming-soon">{t.comingSoonLine}</p>
      )}
    </div>
  );
};
